module.exports = "/_next/static/images/63d4170c89e8afea0396eb67bd63f669-merchant.svg";